<template>
	<div class="plug">
		<v-progress-circular
			:size="50"
			color="primary"
			indeterminate
		></v-progress-circular>
	</div>
</template>

<script>
  export default {
    name: "LoadingPlug",
  }
</script>

<style scoped>
	div.plug {
		background-color: rgba(0, 0, 0, 0.35);
		height: 100%;
		width: 100%;
		position: absolute;
		z-index: 999999;
		text-align: center;
		padding-top: 30vh;
	}
</style>